import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@apollo/client";
import { useNavigation } from "@react-navigation/native";
import { graphql } from "@oui/lib/src/graphql/tada";
import { useTheme } from "../../styles";
import { Button } from "../Button";
import { Heading, Label, Text } from "../Text";
import { View } from "../View";
export var LessonsLearnedQuery = graphql("\n  query LessonsLearned {\n    lessonLearned {\n      createdAt\n      session\n      text\n    }\n  }\n");
/**
 * This component displays a list of "lessons learned" entries and provides an
 * option to edit them.
 *
 * Uses the <https://ouihealth.atlassian.net/browse/APICORE-81> to fetch
 * existing lesson learned entries.
 *
 * Provides an edit button that navigates to the
 * <https://ouihealth.atlassian.net/browse/LESSONS-5>&#x20;
 *
 * If no lessons exist, displays a placeholder text "Complete session 1".
 *
 * [Figma File](https://www.figma.com/file/LIbbnQ2oap9fGyvizt5KnA/Lessons-learned?type=design\&node-id=0%3A1\&mode=design\&t=BZzmA4MSrjp5XCsj-1)
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-11}
 */ export var LessonsLearned = function() {
    var _data_lessonLearned, _data_lessonLearned1;
    var theme = useTheme().theme;
    var data = useQuery(LessonsLearnedQuery).data;
    var navigation = useNavigation();
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            borderRadius: 20,
            backgroundColor: 'white',
            paddingVertical: 15,
            paddingHorizontal: 20,
            gap: 25
        },
        children: [
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        level: 2,
                        text: "Lessons learned",
                        color: theme.color.dark
                    }),
                    (data === null || data === void 0 ? void 0 : (_data_lessonLearned = data.lessonLearned) === null || _data_lessonLearned === void 0 ? void 0 : _data_lessonLearned.length) ? /*#__PURE__*/ _jsx(Button, {
                        variant: "text",
                        iconRight: "edit",
                        "aria-label": "Edit lessons learned",
                        onPress: function() {
                            navigation.navigate('EditLessonsLearned');
                        },
                        color: theme.color.gray400
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsxs(View, {
                style: {
                    gap: 15,
                    padding: 20,
                    borderRadius: 20,
                    borderColor: theme.color.accentTwo300,
                    borderWidth: 1
                },
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        small: true,
                        text: "Lesson from each session",
                        color: theme.color.gray300
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            gap: 15
                        },
                        children: (data === null || data === void 0 ? void 0 : (_data_lessonLearned1 = data.lessonLearned) === null || _data_lessonLearned1 === void 0 ? void 0 : _data_lessonLearned1.length) ? data.lessonLearned.map(function(lesson, index) {
                            return /*#__PURE__*/ _jsxs(View, {
                                row: true,
                                style: {
                                    alignItems: 'flex-start'
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 35
                                            },
                                            text: index + 1,
                                            color: theme.color.gray300
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Label, {
                                        text: lesson.text,
                                        color: theme.color.gray200,
                                        style: {
                                            flex: 1
                                        }
                                    })
                                ]
                            }, index);
                        }) : /*#__PURE__*/ _jsx(Text, {
                            size: 15,
                            text: "Complete session 1",
                            color: theme.color.gray200
                        })
                    })
                ]
            })
        ]
    });
};
